import Vue from "vue";
import VueRouter from "vue-router";
import store from "../store";

Vue.use(VueRouter);

// 解决ElementUI导航栏中的vue-router在3.0版本以上重复点菜单报错问题
const originalPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch((err) => err);
};
const routes = [
  {
    path: "/",
    redirect: "/login",
  },
  {
    path: "/login",
    name: "login",
    component: () => import("../views/login/login.vue"),
  },
  {
    path: "/test",
    name: "test",
    component: () => import("../views/test.vue"),
  },
  {
    path: "/main",
    name: "main",
    component: () => import("../views/main/main.vue"),
    children: [
      {
        path: "/main/backstage",
        name: "backstage",
        component: () => import("../views/main/backstage/index.vue"),
        children: [],
      },
      {
        path: "/main/orderList",
        name: "orderList",
        component: () => import("../views/main/backstage/orderList.vue"),
        children: [],
      },
      {
        path: "/main/manage",
        name: "manage",
        component: () => import("../views/main/backstage/manage.vue"),
        children: [],
      },

      {
        path: "/main/address",
        name: "address",
        component: () => import("../views/main/backstage/address.vue"),
        children: [],
      },
      {
        path: "/main/registercode",
        name: "registercode",
        component: () => import("../views/main/backstage/registercode.vue"),
        children: [],
      },
      {
        path: "/main/checklist",
        name: "checklist",
        component: () => import("../views/main/backstage/checklist.vue"),
        children: [],
      },
      {
        path: "/main/vipreportList",
        name: "vipreportList",
        component: () => import("../views/main/backstage/vipreportList.vue"),
        children: [],
      },
      {
        path: "/main/projectlist",
        name: "projectlist",
        component: () => import("../views/main/backstage/projectlist.vue"),
        children: [],
      },
      {
        path: "/main/vipBackstage",
        name: "vipBackstage",
        component: () => import("../views/main/backstage/vipIndex.vue"),
        children: [],
      },
      {
        path: "/main/reportList",
        name: "reportList",
        component: () => import("../views/main/backstage/reportList.vue"),
        children: [],
      },
      {
        path: "/main/template",
        name: "reportDel",
        component: () => import("../views/main/backstage/template.vue"),
        children: [],
      },
      {
        path: "/main/reportDel",
        name: "reportDel",
        component: () => import("../views/main/backstage/reportDel.vue"),
        children: [],
      },
      {
        path: "/main/authorization",
        name: "authorization",
        component: () => import("../views/main/backstage/authorization.vue"),
        children: [],
      },
      {
        path: "/main/roles",
        name: "roles",
        component: () => import("../views/main/backstage/roles.vue"),
        children: [],
      },
      {
        path: "/main/userAdmin",
        name: "userAdmin",
        component: () => import("../views/main/backstage/userAdmin.vue"),
        children: [],
      },
    ],
  },
  {
    path: "/order",
    name: "order",
    component: () => import("../views/wx/order.vue"),
    children: [],
  },
  {
    path: "/vipOrder",
    name: "vipOrder",
    component: () => import("../views/wx/vipOrder.vue"),
    children: [],
  },
  {
    path: "/report",
    name: "report",
    component: () => import("../views/wx/report.vue"),
    children: [],
  },
  {
    path: "/smsDel",
    name: "smsDel",
    component: () => import("../views/wx/index.vue"),
    children: [],
  },
  {
    path: "/pay",
    name: "pay",
    component: () => import("../views/wx/pay.vue"),
    children: [],
  },
  {
    path: "/activation",
    name: "activation",
    component: () => import("../views/wx/activation.vue"),
    children: [],
  },
  {
    path: "/video",
    name: "video",
    component: () => import("../views/wx/video.vue"),
    children: [],
  },
  {
    path: "/myOrder",
    name: "myOrder",
    component: () => import("../views/wx/myOrder.vue"),
    children: [],
  },
  {
    path: "/doctor",
    name: "doctor",
    component: () => import("../views/wx/doctor.vue"),
    children: [],
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});
const pathList = [
  "login",
  "smsDel",
  "order",
  "myOrder",
  "MpFile",
  "pay",
  "report",
  "doctor",
  "test",
  "video",
  "vipOrder",
  "activation"
];
router.beforeEach((to, from, next) => {
  if (pathList.indexOf(to.name) !== -1) {
    next();
  } else {
    let token = sessionStorage.getItem("token");
    // console.log(token, "tokenInfo");
    if (token === null || token === "") {
      next("/login");
    } else {
      next();
    }
  }
});
export default router;
